export interface UseCase {
  id: string;
  icon: string;
  name: string;
  pain: string;
  vision: string;
}

export const useCases: UseCase[] = [
  {
    id: "k8s",
    icon: "K8",
    name: "Kubernetes operator interview",
    pain: "Generic coding-assessment platforms have no concept of a reconcile loop. You end up asking candidates to describe how they'd implement something instead of watching them do it.",
    vision:
      "The candidate lands in a live k3s cluster. kubectl ready, kubebuilder scaffolded, k9s on the right. The problem is a real PodAutoScaler controller. You see the cluster state update as they work.",
  },
  {
    id: "llvm",
    icon: "λ",
    name: "LLVM / compiler interview",
    pain: "Whiteboard questions about SSA test memorization. They tell you nothing about whether the candidate can use the LLVM API correctly, or read and debug IR under pressure.",
    vision:
      "C++ editor with clangd, terminal with clang, opt, and llvm-lit. An IR viewer panel updates live as they write the pass. You see how they think, not what they claim to know.",
  },
  {
    id: "sre",
    icon: "SR",
    name: "SRE incident response interview",
    pain: "Behavioral questions are easy to embellish. A Prometheus query in a code editor bears no resemblance to how an incident actually unfolds at 3am.",
    vision:
      "Grafana showing a service with elevated error rates. Loki with the logs. kubectl on the affected cluster. The problem is implicit: figure out what's broken and fix it.",
  },
];
